var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.045 11.045a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M8 1.5v1.182M8 13.318V14.5M3.402 3.403l.84.839M11.758 11.758l.84.84M1.5 8h1.182M13.317 8H14.5M3.402 12.597l.84-.839M11.758 4.242l.84-.84"
  })));
};
export default SvgSun;